const isChirpEnumString = value => {
  return typeof value === 'string';
};
export const chirpEnumToString = value => {
  if (isChirpEnumString(value)) {
    return value;
  }
  return undefined;
};